var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from '../elements/svg-circle-icon';
export var CrossFilledIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 36,
    glyphHeight: 37
  }), React.createElement("path", {
    d: "M17.9999 36.9849C27.941 36.9849 35.9999 28.926 35.9999 18.9849C35.9999 9.04374 27.941 0.984863 17.9999 0.984863C8.05875 0.984863 -0.00012207 9.04374 -0.00012207 18.9849C-0.00012207 28.926 8.05875 36.9849 17.9999 36.9849ZM20.524 18.9849L26.83 25.2908L24.3058 27.8149L17.9999 21.509L11.694 27.8149L9.16985 25.2908L15.4758 18.9849L9.16985 12.679L11.694 10.1548L17.9999 16.4607L24.3058 10.1548L26.83 12.679L20.524 18.9849Z"
  }));
};
export var CrossFilledIconGlyph = function (props) {
  return React.createElement(CrossFilledIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};